import axios from 'axios';
import { dataResponseInterceptor } from 'domains/api/interceptors';

export const anonymousExternalAPIClient = axios.create();

anonymousExternalAPIClient.interceptors.response.use(...dataResponseInterceptor);
